import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

/** @type {boolean} */
let leafletInitialized = false;

/**
 * Expose bundled Leaflet on window.L for existing map components.
 * @returns {boolean}
 */
function initializeLeaflet() {
  if (typeof window === "undefined") {
    return false;
  }

  if (leafletInitialized && window.L) {
    return true;
  }

  window.L = L;
  leafletInitialized = true;
  return true;
}

/**
 * Ensures bundled Leaflet is available for map components.
 * @returns {Promise<boolean>}
 */
export function ensureLeafletLoaded() {
  return Promise.resolve(initializeLeaflet());
}

/**
 * Loads bundled Leaflet once and returns whether it is ready.
 * @returns {boolean}
 */
export function useLeafletReady() {
  const [leafletReady, setLeafletReady] = useState(() => initializeLeaflet());

  useEffect(() => {
    let cancelled = false;

    ensureLeafletLoaded().then((ready) => {
      if (!cancelled && ready) {
        setLeafletReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return leafletReady;
}
